import generatedNews from '../generated/news.json';

export const NEWS_DISPLAY_LIMIT = 3;

export const sortNewsItems = items =>
  [...items].sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate));

export const getNewsItems = () => sortNewsItems(generatedNews.items || []);

export const getNewsItem = id =>
  getNewsItems().find(item => item.id === id && !item.isExternal) || null;

export const getNewsCategories = () =>
  [...(generatedNews.categories || [])].sort((a, b) => a.order - b.order);

export const getNewsPath = id => `/news/${encodeURIComponent(id)}/`;

// Translated external titles and destinations are selected as a pair.
export const getNewsLink = (item, locale) => {
  if (!item.isExternal) {
    return { title: item.title, href: getNewsPath(item.id), lang: 'ja' };
  }
  const suffix =
    locale === 'en'
      ? 'En'
      : ['zh-CN', 'zh-TW', 'zh-HK'].includes(locale)
        ? 'Zh'
        : '';
  if (suffix && item[`title${suffix}`] && item[`externalUrl${suffix}`]) {
    return {
      title: item[`title${suffix}`],
      href: item[`externalUrl${suffix}`],
      lang: locale,
    };
  }
  return { title: item.title, href: item.externalUrl, lang: 'ja' };
};
